import { render } from "./Loan.vue?vue&type=template&id=ba4bd088&ts=true"
import script from "./Loan.vue?vue&type=script&lang=ts"
export * from "./Loan.vue?vue&type=script&lang=ts"

import "./Loan.vue?vue&type=style&index=0&id=ba4bd088&lang=css"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__